module.exports = __webpack_public_path__ + "img/unnamed.b034933e.png";